import { BuzerIcon } from "../../../BuzerIcons";
import { Lead } from "./ListRow";
import { ProgressBar } from "./Progress";

// Grouped card for a routine (or any titled cluster): brand icon chip + title +
// count in the header, an optional inset progress bar, a stack of rows
// (children — ListRows), and an optional full-width add-footer.
//
// Slots for real-world headers:
//   headerRight  — node after the count (chevron, reorder arrows…)
//   onHeaderClick— makes the header a button (e.g. collapse toggle)
//   headerProps  — extra props spread on the header (pointer handlers for hold)
//   collapsed    — hide progress, rows and footer (header stays)
// Children go in a wrapper so the first ListRow drops its top hairline.
export function GroupCard({
  icon, iconStyle, onIconClick, title, count, pct, headerRight, onHeaderClick, headerProps,
  collapsed = false, done = false, onAdd, addLabel = "Pridať návyk", children,
}) {
  const iconChip = icon != null && (
    <Lead tone="outline" size="sm" style={iconStyle}>
      {typeof icon === "string" ? <BuzerIcon name={icon} size={18} color="currentColor" /> : icon}
    </Lead>
  );
  const HeadTag = onHeaderClick ? "button" : "div";
  const headStyle = onHeaderClick
    ? { width: "100%", background: "none", border: "none", cursor: "pointer", font: "inherit", textAlign: "left", color: "inherit", WebkitTextFillColor: "currentColor" }
    : undefined;
  return (
    <div className="bz-card bz-card--flush" style={done ? { background: "var(--page-grad)", boxShadow: "none" } : undefined}>
      <HeadTag type={onHeaderClick ? "button" : undefined} className="bz-group__head" onClick={onHeaderClick} style={headStyle} {...headerProps}>
        {onIconClick
          ? <span role="button" tabIndex={0} aria-label="Detail skupiny" onClick={(e) => { e.stopPropagation(); onIconClick(); }} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); e.stopPropagation(); onIconClick(); } }} style={{ cursor: "pointer", display: "inline-flex" }}>{iconChip}</span>
          : iconChip}
        <span className="bz-group__title">{title}</span>
        <span style={{ flex: 1 }} />
        {count != null && <span className="bz-group__count">{count}</span>}
        {headerRight}
      </HeadTag>
      {pct != null && !collapsed && <div className="bz-group__progress"><ProgressBar pct={pct} size="sm" /></div>}
      {!collapsed && <div className="bz-group__rows">{children}</div>}
      {onAdd && !collapsed && (
        <button type="button" className="bz-group__add" onClick={onAdd}>
          <BuzerIcon name="add" size={16} color="currentColor" strokeWidth={2.2} />{addLabel}
        </button>
      )}
    </div>
  );
}
